/**
 * MobileMenu Module
 * helper class
 */
export default class {
  /**
   * constructor
   */
  constructor() {
    this.list = document.querySelector('[data-mobile-nav]');
    this.checkbox = document.querySelector('[data-hamburger-input]');
    this.overlay = document.querySelector('[data-mobile-overlay]');
    this.body = document.querySelector('body');
    this.bodyStyle = this.body.style;
    this.scrollPosition = 0;
    this.mql = window.matchMedia('(min-width: 1024px)');

    try {
      //  Chrome & Firefox
      this.mql.addEventListener('change', () => this.breakpointHandler());
    } catch (e1) {
      try {
        //  Safari
        this.mql.addListener(() => this.breakpointHandler());
      } catch (e2) {
        console.error(e2);
      }
    }

    this.checkbox.addEventListener('click', (event) => this.checkboxClickHandler(event));
    this.list.addEventListener('click', (event) => this.mobileNavClickHandler(event));
  }

  /**
   * enableScrollLock
   * @desc locks the body in place
   *   locks scroll position
   */
  enableScrollLock() {
    this.scrollPosition = window.pageYOffset;
    this.bodyStyle.overflow = 'hidden';
    this.bodyStyle.position = 'fixed';
    this.bodyStyle.width = '100%';
  }

  /**
   * disableScrollLock
   * @desc restores body scroll
   *   restores scroll position
   */
  disableScrollLock() {
    this.bodyStyle.removeProperty('overflow');
    this.bodyStyle.removeProperty('position');
    this.bodyStyle.removeProperty('width');
    window.scrollTo(0, this.scrollPosition);
  }

  /**
   * event listener for the mobile header hamburger
   * @desc hide/show overlay
   *   allow/prevent scroll on body
   * @param {ClickEvent} event
   */
  checkboxClickHandler(event) {
    if (this.checkbox.checked) {
      this.overlay.classList.add('mobile-overlay--show');
      this.enableScrollLock();
    } else {
      this.overlay.classList.remove('mobile-overlay--show');
      this.disableScrollLock();
    }
  }

  /**
   * event listener for mobile nav list
   * @desc hide overlay
   *   reset checkbox (for css animation)
   *   reset overflow on html tag
   * @param {ClickEvent} event
   */
  mobileNavClickHandler(event) {
    this.overlay.classList.remove('mobile-overlay--show');
    this.checkbox.checked = false;
    this.disableScrollLock();
  }

  /**
   * mql listener for min-width
   * @desc hide overlay
   *   reset checkbox (for css animation)
   *   reset overflow on html tag
   */
  breakpointHandler() {
    if (this.mql.matches) {
      this.overlay.classList.remove('mobile-overlay--show');
      this.checkbox.checked = false;
      this.disableScrollLock();
    }
  }
}
